export default "__VITE_ASSET__QP6NcRNH__"